// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2y9Af","Label":"BuildControl_Label__3NpDA","Less":"BuildControl_Less__l4GY0","More":"BuildControl_More__2cySB"};